export { default as CodeSetVolumeGap } from './CodeSetVolumeGap';
// CodeSetVolumeGapV2 is intentionally NOT barrel-exported to avoid pulling
// its dependency chain (d3, widgetRenderer) into profileWidgetConfig.
// Import directly: import CodeSetVolumeGapV2 from '.../CodeSetVolumeGapV2';
